import React from "react";
// import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Link,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { BrandLogo } from "@theatticusapp/atticus-shared-components";
import { AuthCircle } from "../../components/AuthCircle";
import { useAuthContext } from "../../AuthContextWrapper";

interface Props {
  elevation?: number;
  onMobileNavOpen: () => void;
}

const TopBar = ({ elevation, onMobileNavOpen }: Props): JSX.Element => {
  const theme = useTheme();
  const centerLogo = useMediaQuery(theme.breakpoints.down("sm"));
  const { activeEstate, user } = useAuthContext()

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "background.paper",
        display: {
          md: "none",
        },
      }}
      elevation={elevation}
    >
      <Toolbar
        sx={{
          pl: "10px",
          minHeight: {
            sm: "56px", // override MUI responsive sm
          },
          paddingLeft: {
            sm: "10px", // override MUI responsive sm
          },
          gap: "10px",
        }}
      >
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon
              sx={{
                color: "common.black",
              }}
            />
          </IconButton>
        </Hidden>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: centerLogo ? "center" : "flex-start",
            flex: 1,
          }}
        >
          <Link
            href="/app/home"
            sx={{
              display: "flex",
            }}
          >
            <BrandLogo
              advisorGroupKey={
                activeEstate?.advisorGroup?.title || user?.advisorGroupName
              }
              sx={{
                maxHeight: "30px",
              }}
            />
          </Link>
        </Box>
        <AuthCircle  />
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
